import ApiService from '@/services/api';
import { EntityBuilder } from '@decahedron/entity';
import Car from '@/entities/Car';
import CarOption from '@/entities/CarOption';

let instance: CarService = null;

export default class CarService {
  apiService: ApiService = null;

  carsList: Car[] = null;

  car: Car = null;

  constructor() {
    if (!instance) {
      this.apiService = new ApiService();
      instance = this;
    }

    return instance;
  }

  get list(): Car[] {
    if (!this.carsList) {
      this.setList();
    }

    return this.carsList;
  }

  setCarList(cars: Car[]) {
    let position = 1;
    this.carsList = cars.sort((a: Car, b: Car) => a.position - b.position).map((car: Car) => {
      const carCopy = car;
      carCopy.position = position;
      position += 1;

      return carCopy;
    });
  }

  protected setList() {
    this.carsList = [];
    this.getList().then((cars: Car[]) => {
      this.setCarList(cars);
    });
  }

  protected getList() {
    return this.apiService.get('cars')
      .then((response) => EntityBuilder.buildMany<Car>(Car, response.data));
  }

  get(id: string): Promise<Car> {
    this.car = this.list.find((car) => car.id === id);

    return this.apiService.get(`cars/${id}`)
      .then((response) => EntityBuilder.buildOne(Car, response.data));
  }

  props() {
    return this.apiService.get('cars/props')
      .then((props) => {
        const copy = props;
        copy.options = EntityBuilder.buildMany<CarOption>(CarOption, props.options);

        return copy;
      });
  }

  move(from: number, to: number) {
    for (let i = 0; i < this.list.length; i += 1) {
      if (i === from) {
        this.list[i].position = to + 1;
      } else if (from < to && i > from && i <= to) {
        this.list[i].position -= 1;
      }
      if (from > to && i < from && i >= to) {
        this.list[i].position += 1;
      }
    }

    this.setCarList(this.list);
  }

  saveOrder(cars: Car[]) {
    return this.apiService.put('cars/position', cars.map((car: Car) => {
      const carCopy = car;
      return {
        id: carCopy.id,
        position: carCopy.position,
      };
    }));
  }

  save(car: Car) {
    if (car.id) {
      return this.apiService.put(`cars/${car.id}`, car.toJson())
        .then((response) => {
          this.setList();
          return EntityBuilder.buildOne<Car>(Car, response.data);
        });
    }

    return this.apiService.post('cars', car.toJson())
      .then((response) => {
        this.setList();
        return EntityBuilder.buildOne<Car>(Car, response.data);
      });
  }

  delete(car: Car) {
    return this.apiService.put(`cars/${car.id}/archive`)
      .then((response) => {
        if (this.carsList?.length) {
          for (let n = 0; n < this.carsList.length; n += 1) {
            if (this.carsList[n].id === car.id) {
              this.carsList.splice(n, 1);
              break;
            }
          }
        }

        return response;
      });
  }
}
